// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-description[data-v-10fcea52]{padding:12px}`, "",{"version":3,"sources":["webpack://./apps/settings/src/components/AppStoreSidebar/AppDescriptionTab.vue"],"names":[],"mappings":"AACA,kCACC,YAAA","sourcesContent":["\n.app-description {\n\tpadding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
